<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FDCE48" right timeout="3000">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #000">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex
        xs12
        pt-1
        style="font-family: poppinssemibold; font-size: 22px"
        class="clr"
      >
        <h3>Edit Grocery Product</h3>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 md6 lg3>
        <v-text-field label="Name" v-model="name"> </v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg3 pl-2>
        <v-select
          label="Category"
          :items="CategoryList"
          v-model="category"
          item-text="name"
          item-value="_id"
        >
        </v-select>
      </v-flex>
      <v-flex xs12 md6 lg3 pl-2>
        <v-select
          :items="SubCategoryList"
          v-model="Subcategory"
          item-text="name"
          item-value="_id"
          label="Sub Category"
        >
        </v-select>
      </v-flex>
      <v-flex xs12 md6 lg3>
        <v-select
          :items="foodTypes"
          v-model="foodType"
          type="number"
          prepend-icon="mdi-egg"
          label="Type"
        >
        </v-select>
      </v-flex>
      <!-- <v-flex xs12 lg3 px-1>
        <v-select
          :items="Brands"
          item-text="brandName"
          item-value="_id"
          label="Brand"
          v-model="brand"
        >
        </v-select>
      </v-flex> -->
      <v-flex xs12 lg12>
        <v-form ref="form">
          <v-textarea
            :rules="[rules.length]"
            v-model="description"
            label="Description"
          >
          </v-textarea>
        </v-form>
      </v-flex>
      <v-flex xs12 lg3>
        <v-autocomplete
          :items="HSNList"
          item-text="hsnCode"
          item-value="_id"
          type="number"
          v-model="HSNCode"
          label="HSN Code"
          @input="ChangeHSN(HSNCode)"
        >
        </v-autocomplete>
      </v-flex>

      <v-flex xs12 lg3 pl-3>
        <v-text-field
          disabled
          type="number"
          label="GST Slab1 percentage"
          prepend-inner-icon="mdi-percent"
          v-model="Slab1percentage"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 lg3 pl-3>
        <v-text-field
          disabled
          type="number"
          v-model="Slab2percentage"
          prepend-inner-icon="mdi-percent"
          label="GST Slab2 percentage"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 lg3 pl-3>
        <v-text-field
          disabled
          type="number"
          v-model="Slab2price"
          prepend-inner-icon="mdi-currency-inr"
          label="GST Slab2 price"
        >
        </v-text-field>
      </v-flex>

      <v-flex xs12 pl-2 v-if="HSNName != null">
        <v-card style="border-radius: 20px" color=" #ffd633">
          <v-layout wrap pa-1>
            <v-flex xs12>
              {{ HSNName }}
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex xs12 v-for="(item, i) in variants" :key="i" pt-2>
        <v-layout wrap>
          <v-flex xs12 lg3 px-1>
            <v-text-field label="Variant Name *" v-model="item.varientName">
            </v-text-field>
          </v-flex>
          <!-- <v-flex xs12 lg3 px-1>
            <v-text-field
              type="number"
              label="Price"
              v-model="item.price"
              @input="checkDiscountvariant(i)"
            >
            </v-text-field>
          </v-flex> -->
          <v-flex xs12 lg3 px-1>
            <v-text-field
              type="number"
              label="Product Weight* (Kg) "
              v-model="item.productWeight"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 lg3 px-1>
            <v-select
              label="Quantity Type *"
              v-model="item.quantityType"
              :items="quantityTypes"
            >
            </v-select>
          </v-flex>
          <v-flex xs12 lg3 px-1>
            <v-text-field
              type="number"
              :label="'Quantity *(' + item.quantityType + ')' "
              v-model="item.quantity"
            >
            </v-text-field>
          </v-flex>

          <!-- <v-flex xs12 lg3 px-1>
            <v-text-field
              type="number"
              label="Discount"
              @input="checkDiscountvariant(i)"
              v-model="item.discount"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 lg3 px-1>
            <v-text-field
              @input="checkOfferPricevariant(i)"
              type="number"
              label="offerPrice"
              v-model="item.offerPrice"
            >
            </v-text-field>
          </v-flex>

          <v-flex xs12 lg3 px-1>
            <v-menu
              ref="variants1"
              v-model="item.menu"
              :close-on-content-click="false"
              :return-value.sync="item.manufacturingDate"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.manufacturingDate"
                  :rules="[rules.required]"
                  label="Manufacturing Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="item.manufacturingDate"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="item.menu = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.variants1[i].save(item.manufacturingDate)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 lg3 px-1>
            <v-menu
              ref="variants"
              v-model="item.menu1"
              :close-on-content-click="false"
              :return-value.sync="item.expiryDate"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :rules="[rules.required]"
                  v-model="item.expiryDate"
                  label="Select Expiry Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="item.expiryDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="item.menu1 = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.variants[i].save(item.expiryDate)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 lg3 px-1>
            <v-text-field label="Shelf Life" v-model="item.shelfLife">
            </v-text-field>
          </v-flex>

          <v-flex xs12 lg3 px-2 pb-lg-2>
            <span text-left style="font-size: 12px; color: grey"
              >Choose Commission Type</span
            >
            <v-radio-group v-model="item.commissionType" mandatory>
              <v-layout wrap>
                <v-flex xs6>
                  <v-radio
                    color="yellow"
                    label="Percentage"
                    value="percentage"
                  ></v-radio
                ></v-flex>
                <v-flex xs6>
                  <v-radio
                    color="yellow"
                    label="Amount"
                    value="amount"
                  ></v-radio
                ></v-flex>
              </v-layout>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 lg3 px-2>
            <v-text-field
              :disabled="item.commissionType == 'percentage' ? false : true"
              @input="checkDiscountvariant(i)"
              ref="commissionPercentage"
              :rules="[rules.required]"
              prepend-icon="mdi-percent"
              v-model="item.commissionPercentage"
              label="Commission Percentage"
            >
            </v-text-field>
          </v-flex>
         
          <v-flex xs12 lg3 px-2>
            <v-text-field
              :disabled="item.commissionType == 'amount' ? false : true"
              @input="checkOfferPricevariant(i)"
              :rules="[rules.required]"
              prepend-icon="mdi-currency-inr"
              v-model="item.commission"
              label="Commission Amount"
            >
            </v-text-field>
          </v-flex> -->

          <v-flex xs12 lg3 px-2>
            <v-text-field
              type="number"
              prepend-inner-icon="mdi-numeric"
              v-model="item.minimumOrderQuantity"
              label="Minimum Order Quantity *"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 lg3 px-2>
            <v-text-field
              type="number"
              prepend-inner-icon="mdi-numeric"
              v-model="item.maxOrderQuantity"
              label="Maximum Order Quantity *"
            >
            </v-text-field>
          </v-flex>

          <!-- <v-flex xs12 lg3 px-2> </v-flex> -->
          <v-flex xs12 text-left pt-3 pb-1>
            <span>Product Detail</span> <br />
            <vue-editor class="pt-1" v-model="item.productDetails">
            </vue-editor>
          </v-flex>

          <v-flex xs12 md12 lg4 pb-4>
            <ImageComp
              @stepper="winStepper"
              :singleImage="item.photo"
              :height="'10'"
              :width="'10'"
              :heading="'Upload Main Image'"
              :componentType="'offerImage'"
              :index="i"
            />
          </v-flex>
          <v-flex xs12 md12 lg4 pb-4 px-1>
            <ImageComp
              @stepper="winStepper"
              :singleImage="item.packedPhoto"
              typr
              :height="'10'"
              :width="'10'"
              :heading="'Upload Product Image'"
              :componentType="'restaurantImage'"
              :index="i"
            />
          </v-flex>
          <v-flex xs12 md12 lg4 pb-4>
            <ImageComp
              @stepper="winStepper"
              :singleImage="item.productPhoto"
              typr
              :height="1"
              :width="1"
              :heading="'Upload Packing Image'"
              :componentType="'packingImage'"
              :index="i"
            />
          </v-flex>
          <v-flex xs12 px-1 align-self-baseline pt-1 text-right>
            <v-btn
              v-if="i > 0"
              color="error"
              rounded
              @click="
                variants.splice(i, 1),
                  productImages.splice(i, 1),
                  packingImages.splice(i, 1),
                  packedImages.splice(i, 1),
                  deleteVariant(item)
              "
            >
              <v-icon>mdi-minus</v-icon></v-btn
            >
          </v-flex>

          <v-flex xs12 pt-4 style="border-bottom: 3px solid black"> </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 lg12 pt-3 text-right>
        <v-btn
          dark
          dense
          color="primary"
          style="text-decoration: none"
          rounded
          @click="addVariant"
        >
          add variant <v-icon x-small>mdi-plus</v-icon></v-btn
        >
      </v-flex>
      <v-flex xs12 lg12 pt-3>
        <v-btn
          dark
          dense
          block
          color="black"
          style="text-decoration: none"
          @click="UploadData()"
        >
          Save
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import ImageComp from "@/components/Common/GroceryImage";
export default {
  components: {
    ImageComp,
  },
  data() {
    return {
      Slab1percentage: null,
      Slab2percentage: null,
      Slab2price: null,
      HSNCode: null,
      HSNName: null,
      menu: false,
      menu1: false,
      ServerError: false,
      showSnackBar: false,
      msg: "",
      productImages: [],
      packingImages: [],
      packedImages: [],
      Brands: [],
      brand: null,
      productDetail: null,
      variants: [
        {
          menu: false,
          menu1: false,
          commissionType: null,
          commissionPercentage: 0,
          commission: 0,
          varientName: null,
          price: null,
          productWeight: null,
          quantityType: null,
          quantity: null,
          discount: 0,
          offerPrice: null,
          index: null,
          brand: null,
        },
      ],
      singleVariant: {
        menu: false,
        menu1: false,
        commissionType: null,
        commissionPercentage: 0,
        commission: 0,
        varientName: null,
        price: null,
        productWeight: null,
        quantityType: null,
        quantity: null,
        discount: 0,
        offerPrice: null,
        index: null,
      },
      description: null,
      name: null,
      CategoryList: [],
      category: null,
      SubCategoryList: [],
      Subcategory: null,
      foodTypes: ["Vegetarian", "Non-vegetarian", "Eggetarian"],
      quantityTypes: ["Kilogram", "Gram", "Litre", "Milli litre", "Count"],
      foodType: null,

      //size
      appLoading: false,

      rules: {
        length: (value) => value.length >= 150 || "min 150 characters",
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        discount: (value) =>
          (value < 100 && value >= 0) || "Discount must be between 0-100",
        offerPrice: (value) => value >= 0 || "Offer price should be valid ",
      },
    };
  },
  computed: {
    HSNList() {
      return this.$store.state.HSNList;
    },
  },

  watch: {
    category() {
      this.getSubCategory(this.category);
    },
  },
  mounted() {
    this.getProductTypes();
    this.getCategories();
    this.getAllergens();
    this.getCategory();
    this.getData();
    this.getBrands();
  },
  methods: {
    getCurrentHSN(value) {
      this.HSNCode = null;
      var index = this.SubCategoryList.findIndex(
        (myval) => myval._id === value
      );
      this.HSNCode = this.SubCategoryList[index].hsnCodeId._id;
      this.HSNName = this.SubCategoryList[index].hsnCodeId.name;
    },

    ChangeHSN(HSN) {
      let myname = null;
      myname = this.HSNList.find(changeName);
      function changeName(value) {
        if (value._id === HSN) {
          return value.name;
        }
      }
      this.HSNName = myname.name;
      this.Slab1percentage = myname.gstSlab1Percentage;
      this.Slab2percentage = myname.gstSlab2Percentage;
      this.Slab2price = myname.gstSlab2MinimumPrice;
    },

    getBrands() {
      this.appLoading = true;
      axios({
        url: "/grocery/brand/get/list",
        method: "get",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.Brands = response.data.data;
          // this.pages = response.data.totalPages;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteVariant(value) {
      console.log("value", value);

      if (!value._id) return;
      else {
        this.appLoading = true;
        axios({
          method: "post",
          url: "/grocery/varient/delete",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            id: value._id,
          },
        }).then((response) => {
          if (response.data.status) {
            //   this.addons = response.data.data.addOnIds;
            this.appLoading = false;
            this.showSnackBar = true;
            this.msg = response.data.msg;
            // console.log(this.products);
          } else {
            this.appLoading = false;
            this.showSnackBar = true;
            this.msg = response.data.msg;
            console.log("no data ");
          }
        });
      }
    },

    getData() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "/grocery/admin/product/view",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: this.$route.query.id,
        },
      }).then((response) => {
        if (response.data.status) {
          this.productDetail = response.data.data;

          this.sellers = response.data.data;
          this.variants = response.data.varients;

          for (let i = 0; i < this.variants.length; i++) {
            if (this.variants[i].expiryDate != null) {
              this.variants[i].expiryDate = this.variants[i].expiryDate.slice(
                0,
                10
              );
              console.log("--", this.variants[i].expiryDate);
            }
            if (this.variants[i].manufacturingDate != null) {
              this.variants[i].manufacturingDate = this.variants[
                i
              ].manufacturingDate.slice(0, 10);
            }
          }
          this.name = response.data.data.productId.name;
          this.category = response.data.data.categoryId._id;
          this.Subcategory = response.data.data.subcategoryId._id;
          this.foodType = response.data.data.productId.type;
          this.description = response.data.data.productId.description;
          this.productDetail = response.data.data.productId.productDetails;
          this.HSNCode = response.data.data.hsnCodeId._id;
          this.HSNName = response.data.data.hsnCodeId.name;
          this.brand = response.data.data.brandId;

          this.Slab1percentage =
            response.data.data.hsnCodeId.gstSlab1Percentage;
          this.Slab2percentage =
            response.data.data.hsnCodeId.gstSlab2Percentage;
          this.Slab2price = response.data.data.hsnCodeId.gstSlab2MinimumPrice;

          //   this.addons = response.data.data.addOnIds;
          this.appLoading = false;
          console.log(this.products);
        } else {
          this.appLoading = false;
          this.showSnackBar = true;
          this.msg = response.data.msg;
          console.log("no data ");
        }
      });
    },
    ///////////////////////////////////////
    checkOfferPricevariant(index) {
      if (typeof this.variants[index].offerPrice == "string") {
        this.variants[index].offerPrice = parseInt(
          this.variants[index].offerPrice
        );
      }
      if (this.variants[index].offerPrice <= this.variants[index].price) {
        this.variants[index].discount = (
          100 -
          (this.variants[index].offerPrice / this.variants[index].price) * 100
        ).toFixed(2);
      } else {
        this.msg = "Please Provide valid offer price";
        this.snackbar = true;
        this.offerPrice = this.price;
        this.discount = 0;
      }

      if (this.variants[index].offerPrice >= this.variants[index].commission) {
        this.variants[index].commissionPercentage = (
          ((this.variants[index].offerPrice -
            (this.variants[index].offerPrice -
              this.variants[index].commission)) /
            this.variants[index].offerPrice) *
          100
        ).toFixed(2);
      } else {
        this.msg = "Please Provide valid commission price";
        this.snackbar = true;
        this.variants[index].offerPrice = this.variants[index].price;
        this.variants[index].commission = 0;
        this.variants[index].commissionPercentage = 0;
        this.variants[index].discount = 0;
      }
    },
    UploadData() {
      if (this.$refs.form.validate()) {
        for (let i = 0; i < this.variants.length; i++) {
          this.variants[i].index = i;
        }
        this.appLoading = true;

        axios({
          url: "/grocery/products/edit",
          method: "post",
          headers: {
            token: localStorage.getItem("token"),
          },

          data: {
            id: this.$route.query.productId,
            hsnId: this.HSNCode,
            categoryId: this.category,
            subcategoryId: this.Subcategory,
            type: this.foodType,
            name: this.name,
            description: this.description,
            productDetails: this.productDetail,
            varient: this.variants,
          },
        })
          .then((response) => {
            if (response.data.status) {
              (this.showSnackBar = true),
                (this.msg = response.data.msg),
                (this.PRIDS = response.data.varient);

              if (
                this.productImages.length > 0 ||
                this.packingImages.length > 0 ||
                this.packedImages.length > 0
              ) {
                for (let i = 0; i < this.PRIDS.length; i++) {
                  let A = new FormData();
                  A.append("id", this.PRIDS[i]._id);
                  if (this.productImages.length > 0) {
                    A.append("photo", this.productImages[i]);
                  }
                  if (this.packingImages.length > 0) {
                    A.append("productPhoto", this.packingImages[i]);
                  }
                  if (this.packedImages.length > 0) {
                    A.append("packedPhoto", this.packedImages[i]);
                  }

                  axios({
                    url: "/grocery/upload/product/image",
                    method: "POST",
                    headers: {
                      token: localStorage.getItem("token"),
                    },
                    data: A,
                  })
                    .then((response) => {
                      this.appLoading = false;

                      this.pages = response.data.totalPages;
                    })
                    .catch((err) => {
                      this.appLoading = false;
                      this.ServerError = true;
                      console.log(err);
                    });
                }
                this.appLoading = false;
              }
              this.appLoading = false;
              setTimeout(() => this.$router.go(-1), 2000);
            } else {
               this.appLoading = false;
              this.showSnackBar = true;
              this.msg = response.data.msg;
            }

            // this.getData();
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },

    winStepper(window_data) {
      if (window_data.type == "offerImage") {
        // this.itemImage = window_data.selectedFiles;
        this.productImages[window_data.index] = window_data.selectedFiles;
      }
      if (window_data.type == "packingImage") {
        this.packingImages[window_data.index] = window_data.selectedFiles;
      }
      if (window_data.type == "restaurantImage") {
        this.packedImages[window_data.index] = window_data.selectedFiles;
      }
    },

    checkDiscountvariant(index) {
      if (
        this.variants[index].discount >= 0 &&
        this.variants[index].discount < 100
      ) {
        this.variants[index].offerPrice = (
          this.variants[index].price -
          (this.variants[index].price * this.variants[index].discount) / 100
        ).toFixed(2);
      } else {
        this.msg = "Please Provide valid discount";
        this.snackbar = true;
        this.variants[index].offerPrice = 0;
        this.variants[index].discount = 0;
      }
      if (
        this.variants[index].commissionPercentage >= 0 &&
        this.variants[index].commissionPercentage < 100
      ) {
        this.variants[index].commission =
          (this.variants[index].offerPrice *
            this.variants[index].commissionPercentage) /
          100;
      } else {
        this.msg = "Please Provide valid commission percentage";
        this.snackbar = true;
      }
    },

    addVariant() {
      this.variants.push({ ...this.singleVariant });
    },

    getCategory() {
      this.appLoading = true;
      axios({
        url: "/grocery/category/list/62b16b36fdd907192c69f476",
        method: "get",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.CategoryList = response.data.data;
          this.pages = response.data.totalPages;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getSubCategory(item) {
      this.appLoading = true;
      axios({
        url: "/grocery/subcategory/list/" + item,
        method: "get",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;

          this.SubCategoryList = response.data.data;

          //   this.pages = response.data.totalPages;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getWeek() {
      if (this.isEntireWeek) this.availableDays = this.weekdays;
      if (this.isEntireWeek == false) this.availableDays = [];
    },
    formatTime(item) {
      if (!item) return;
      var hours = Number(item.split(":")[0]);
      var minutes = Number(item.split(":")[1]);
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    openDialog(start, end, item, index) {
      this.estart = start;
      this.availableDays = item.availableDays;
      this.eend = end;
      this.editingItem = item;
      this.editingItem.index = index;
      this.estart = this.editingItem.start;
      this.eend = this.editingItem.end;
      this.EditTimingDialog = true;
    },

    addTiming() {
      this.CommonFields.availableTimings.push({
        start: this.startTime,
        end: this.endTime,
        availableDays: this.availableDays,
      });

      this.startTime = null;
      this.endTime = null;
      this.availableDays = [];
      this.addTimingDialog = false;
      this.isEntireWeek = false;
    },

    getProductTypes() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/seller/type/list/",
        params: {
          userid: this.$route.query.seller,
        },
      }).then((response) => {
        if (response.data.status) {
          this.productTypes = response.data.data;
          this.appLoading = false;
        } else {
          this.appLoading = false;
        }
      });
    },
    getCategories() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/seller/category/list/",
        params: {
          userid: this.$route.query.seller,
        },
      }).then((response) => {
        if (response.data.status) {
          this.categories = response.data.data;
          this.appLoading = false;
        } else {
          this.appLoading = false;
        }
      });
    },
    getAllergens() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/allergens/list",
      }).then((response) => {
        if (response.data.status) {
          this.allergensList = response.data.data;
          this.appLoading = false;
        } else {
          this.appLoading = false;
        }
      });
    },
  },
};
</script>